import * as React from "react";

const MOBILE_BREAKPOINT = 768;

// Seeded from the real viewport on first render (the app uses createRoot, not
// hydration, so there is no server markup to match). Starting at `false`
// made every phone paint the desktop variant first, e.g. two stacked
// calendar months collapsing to one a frame later.
const readIsMobile = () =>
  typeof window !== "undefined" ? window.innerWidth < MOBILE_BREAKPOINT : false;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(readIsMobile);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => setIsMobile(readIsMobile());
    mql.addEventListener("change", onChange);
    setIsMobile(readIsMobile());
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
